import altContentImage from 'assets/images/sgp/10x15/alt-content-image.webp';
import demand from 'assets/images/sgp/10x15/demand.svg';
import garage from 'assets/images/sgp/10x15/garage.svg';
import moving from 'assets/images/sgp/10x15/moving.svg';
import saveMoney from 'assets/images/sgp/10x15/save-money.svg';
import selfStorage from 'assets/images/sgp/5x5/storage-unit-size.webp';
import measured from 'assets/images/sgp/5x5/how-storage-unit-measured.webp';
import tenIntoTen from 'assets/images/sgp/10x15/10x10-storage.webp';
import tenIntoFifteen from 'assets/images/sgp/10x15/10x15-storage-unit.webp';
import sgpHero from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import map from 'assets/images/sgp/10x15/map.svg';
import electricity from 'assets/images/sgp/10x15/electricity.svg';
import cc from 'assets/images/sgp/10x15/CC.svg';
import camera from 'assets/images/sgp/10x15/camera.svg';
import { pageTypes } from 'config/pageTypes';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';
import threeColumnTableImage from 'assets/images/sgp/threeColumnTable.svg';

export const reviews = {
	pageType: pageTypes.SGP,
	title: 'Find Top Rated 10x15 Storage Units with SpareFoot',
	reviews: [
		{
			reviewTitle: 'Easy to register and reserve storage…',
			reviewRating: 5,
			reviewText:
				'Easy to register and reserve a storage unit online, especially on the weekend at the last minute. Would highly recommend to anyone.',
			reviewerInitials: 'RP',
			reviewerName: 'Rodney Parker',
			link: 'https://www.trustpilot.com/reviews/68872403e25bd2ba38525f9b',
		},
		{
			reviewTitle: 'We were able to find storage for travel trailer …',
			reviewRating: 5,
			reviewText:
				'We were able to quickly find storage for our travel trailer, and our unit was within our price range!',
			reviewerInitials: 'DB',
			reviewerName: 'David Blackmon',
			link: 'https://www.trustpilot.com/reviews/68853fd6593fa369951616b8',
		},
		{
			reviewTitle: 'Great Experience.',
			reviewRating: 5,
			reviewText:
				'I had a great experience using SpareFoot to find a storage unit. The platform is incredibly user-friendly and made it easy to compare prices, locations, and unit sizes all in one place. I appreciated the transparency—what you see is what you get, with no hidden fees or surprises.',
			reviewerInitials: 'SW',
			reviewerName: 'Shadeem Whitfield',
			link: 'https://www.trustpilot.com/reviews/687fa9c85ec0038688a21254',
		},
		{
			reviewTitle: 'SpareFoot Website is Easy to Use',
			reviewRating: 5,
			reviewText:
				'The website allowed me to easily search for available storage units in the area I wanted. Once I found one, it only took minutes to reserve!',
			reviewerInitials: 'RS',
			reviewerName: 'Robert Streich',
			link: 'https://www.trustpilot.com/reviews/687915adb981a9b597b9949f',
		},
	],
};

const faqs = [
	{
		question: 'How much can fit in a 10x15 storage unit?',
		answer:
			'A 10x15 storage unit can hold plenty of your belongings. You can fit the entire contents of a 2–3 bedroom home, including furniture like sofas, beds, dining sets, and appliances.\n\n' +
			'For vehicles, most standard cars fit comfortably with additional room for boxes and smaller items. If you are storing business inventory, you might fit 200–300 small to medium boxes, office furniture, or seasonal merchandise displays.',
	},
	{
		question: 'Can a car fit in a 10x15 storage unit?',
		answer:
			"Yes! Most standard vehicles fit comfortably in a 10x15 storage unit. The dimensions provide enough length for cars up to about 17-18 feet long and width for vehicles up to 6-7 feet wide. This includes most sedans, small to mid-size SUVs, pick up trucks and small boats. You'll typically have additional space around the vehicle for boxes, seasonal items, or equipment.\n\n" +
			"It's important to measure your specific vehicle before renting. Trucks with extended cabs, large SUVs, or vehicles with unusual dimensions might be tight fits. Consider the door opening height if you have a lifted vehicle or tall recreational equipment.",
	},
	{
		question:
			"What's the difference between climate-controlled 10x15 units and regular self-storage?",
		answer:
			'A climate-controlled 10x15 storage unit maintains consistent temperature (usually 55–85°F) and humidity levels (typically 30–50%), while standard units fluctuate with outside weather conditions.\n\n' +
			'This protection is crucial for sensitive items like electronics, photographs, documents, wooden furniture, musical instruments, and clothing. Without climate control, these items can suffer damage from extreme temperatures, moisture, mold, and mildew.\n\n' +
			'Climate-controlled units typically cost $20–50 more per month. This investment often pays for itself by preventing damage to valuable items. Climate control is essential if you are storing antiques, artwork, wine, or anything vulnerable to environmental extremes.',
	},
	{
		question: 'How do I organize a 10x15 storage unit?',
		answer:
			'Smart organization starts with planning before you pack. Create an inventory list and sketch a rough layout of your 10x15 storage unit. Place frequently accessed items near the front and stack boxes with the heaviest on the bottom. Use similar box sizes when possible – they stack better and look neater. Label everything clearly on multiple sides so you can identify the contents from different angles.\n\n' +
			"Maximize storage room by using vertical space. Install shelving units along walls for boxes and smaller items. Leave a center aisle for access to items stored in the back. Wrap furniture in moving blankets or plastic covers for protection. Store appliances upright when possible and ensure they're completely dry before storage. Consider using clear plastic bins for items you might need to access regularly – you can see contents without opening multiple boxes.",
	},
	{
		question: 'Is a 10x15 storage unit worth it compared to other sizes?',
		answer:
			'A 10x15 storage unit offers excellent value for many storage situations. It provides 50% more space than a 10x10 unit for typically only 20-30% more cost, making it more cost-effective per square foot. Compared to jumping up to a 10x20 unit, you save money while still getting ample space for most household storage needs.\n\n' +
			"This size is particularly worthwhile if you're storing the contents of a 2-3 bedroom home, need vehicle storage with extra room, or run a small business requiring inventory space. However, if you only need to store a few boxes or seasonal items, a smaller unit might be more economical. Conversely, if you're storing a large home's contents or multiple vehicles, you might need to step up to a larger size. The 10x15 hits the sweet spot for most people's storage needs without paying for unused space.",
	},
];

const twoColumnTable = {
	title: 'How Big Is a 10x15 Storage Unit?',
	suffix: '### Understanding the Space: 150 Square Feet Explained',
	image: twoColumnTableImage,
	description:
		'A [10x15 storage unit provides 150 square feet](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit) of floor space and typically 1,200-1,500 cubic feet of total storage volume (assuming 8-10 foot ceilings).',
	type: 'sizeChart',
	slug: 'size-chart-section',
	pageType: pageTypes.SGP,
	tableType: 'specialType',
	headers: [
		{
			label: 'Comparison',
			key: 'comparison',
		},
		{
			label: '10x15 Storage Unit',
			key: 'storageUnit',
		},
	],
	rows: [
		{
			comparison: {
				type: 'markdown',
				markdown: '**Floor Space**',
			},
			storageUnit: '150 sq ft',
		},
		{
			comparison: {
				type: 'markdown',
				markdown: '**Cubic Feet**',
			},
			storageUnit: '1,200-1,500 cubic ft',
		},
		{
			comparison: {
				type: 'markdown',
				markdown: '**Real-World Size Comparison**',
			},
			storageUnit: 'About the size of a large bedroom',
		},
		{
			comparison: {
				type: 'markdown',
				markdown: '**Ceiling Height**',
			},
			storageUnit:
				'Typically 8-10 feet, but always check with your specific facility if clearance is important to you.',
		},
	],
};

const threeColumnTable = {
	title: '10x15 Storage Unit Average Costs',
	image: threeColumnTableImage,
	description:
		"Understanding storage costs helps you budget effectively and find the best deals in your area. \n\n Here's what you can expect to pay for a 10x15 storage unit:",
	type: 'sizeChart',
	slug: 'size-chart-section',
	pageType: pageTypes.SGP,
	headers: [
		{
			label: 'Location Type',
			key: 'locationType',
		},
		{
			label: 'Monthly Cost Range',
			key: 'monthlyCostRange',
		},
		{
			label: '10x15 Storage Unit Average Cost',
			key: 'averageCost',
		},
	],
	rows: [
		{
			locationType: {
				type: 'markdown',
				markdown: '**Cities**',
			},
			monthlyCostRange: '$80 - $200',
			averageCost: '$140',
		},
		{
			locationType: {
				type: 'markdown',
				markdown: '**Suburban Areas**',
			},
			monthlyCostRange: '$60 - $150',
			averageCost: '$105',
		},
		{
			locationType: {
				type: 'markdown',
				markdown: '**Rural Areas**',
			},
			monthlyCostRange: '$50 - $120',
			averageCost: '$85',
		},
	],
};

const twoPanelBlock = {
	props: {
		title: 'Popular 10x15 Storage Unit Amenities',
		suffix: 'These amenities may raise your monthly storage costs, but they’re worth it for the added protection they provide.',
		type: 'two-panel',
		content: [
			{
				image: cc,
				description:
					'### Climate Control\n\n Add $20-50/month for temperature and humidity control',
			},
			{
				image: camera,
				description:
					'### Security Features\n\n Premium facilities with advanced security may cost 10-20% more',
			},
		],
	},
};

const threePanelBlock = {
	props: {
		title: 'Factors That Affect Pricing',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: map,
				description:
					'### Location \n\n Units closer to city centers typically cost more',
			},
			{
				image: demand,
				description:
					'### Demand \n\n High-demand areas see seasonal price fluctuations',
			},
			{
				image: electricity,
				description:
					'### Amenities \n\n [Drive-up access](https://www.sparefoot.com/blog/drive-up-storage-units), extended hours, and on-site management can increase costs',
			},
		],
	},
};

const iconContentBlock = {
	headerContent: {
		prefix: '## One of the Most Popular Unit Sizes',
		title: 'Why Choose a 10x15 Storage Unit?',
		description:
			"A 10x15 storage unit hits the sweet spot of space and affordability. Here's why this size is so popular with other storage users:",
	},
	itemsContent: {
		items: [
			{
				icon: saveMoney,
				title: '#### Generous Space Without the Premium Price',
				description:
					'At 150 square feet, you get more room than smaller units without jumping to the high cost of larger storage spaces.',
			},
			{
				icon: demand,
				title: '#### Versatile Storage Solution',
				description:
					'From storing furniture during a move or keeping seasonal decorations organized, a 10x15 unit adapts to your changing needs.',
			},
			{
				icon: garage,
				title: '#### Vehicle-Friendly Dimensions',
				description:
					'Can a [car fit in a 10x15 storage unit](https://www.sparefoot.com/car-storage.html)? It sure can. It’s the perfect place for that old sedan.',
			},
			{
				icon: moving,
				title: '#### Ideal for Life Transitions',
				description:
					'This size accommodates the contents of a 2-3 bedroom apartment or house, [making transitions smoother](https://www.sparefoot.com/blog/temporary-storage-between-moves) and less stressful.',
			},
		],
	},
};

const pageType = 'SGP';

export const TenByFifteenContent = {
	pageType: pageTypes.SGP,
	type: '10x15',
	sections: [
		// Hero Section
		{
			title: '10x15 Storage Units: The Perfect Medium-Size Storage Solution for You',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					background: 'lighterYellow',
					props: {
						content: {
							pageType,
							title: '10x15 Storage Units: The Perfect Medium-Size Storage Solution for You',
							description:
								"Between apartment leases? Downsizing? Need extra space for seasonal items? A 10x15 storage unit gives you the room you need without paying for space you don't. With 150 square feet of storage space, these mid-size units are ideal for storing the contents of a 2-3 bedroom home, vehicles, or small business inventory. Let SpareFoot lead the way in your 10x15 storage unit rental journey.",
							CTAText: 'Search & Compare',
							inputLabel: 'Find Your Ideal 10x15 Storage Unit',
							image: sgpHero,
						},
					},
				},
			],
		},

		// Near By Cities
		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},

		//Alternating Content Block
		{
			title: 'Looking for a Medium Storage Unit?',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: 'Looking for a Medium Storage Unit?',
							description:
								'If you’re here, chances are that you’re looking for a medium storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your medium storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space:',
							additionalProps: {
								paragraph: {
									color: 'black',
								},
							},
							content: [
								{
									image: altContentImage,
									description:
										'**Medium Units:** 10x10, 10x15 (*you are here*), 5x15 \n\n' +
										'**Small Units:** 5x5, 5x10, Mini storage, Storage lockers\n\n' +
										'**Large Units:** 10x20, 10x25, 10x30',
								},
							],
						},
					},
				},
			],
		},

		//Icon Content Block
		{
			title: 'One of the Most Popular Unit Sizes',
			background: 'gray',
			modules: [
				{
					type: 'IconContentBlock',
					props: iconContentBlock,
				},
			],
		},

		//Small Table Block
		{
			title: 'How Big Is a 10x15 Storage Unit?',
			modules: [
				{
					type: 'sizeChart',
					id: 'smallTableBlock',
					props: twoColumnTable,
				},
			],
		},

		// Video Content
		{
			title: 'What Fits in a 10x15 Storage Unit?',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						slug: 'What Fits in a 10x15 Storage Unit?',
						src: 'https://www.youtube.com/embed/rHZsJPfvFtc?si=4lC02yKwAjxrgJNy',
						content: {
							title: 'What Fits in a 10x15 Storage Unit?',
							description:
								'A 10x15 storage unit can accommodate the complete contents of a 2-3 bedroom home, including living room, dining room, and bedroom furniture sets, major appliances, and 40-60 boxes of belongings. The space is also large enough to store most vehicles like cars, trucks, or SUVs, along with recreational items such as motorcycles, small boats, or compact trailers. Additionally, it works well for business needs, providing ample room for office furniture, inventory, seasonal merchandise, and equipment.',
						},
					},
				},
			],
		},

		// Three Column Table
		{
			title: '10x15 Storage Unit Average Costs',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: 'threeColumnTable',
					props: threeColumnTable,
				},
			],
		},

		// Two Panel Block
		{
			title: 'Two Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock',
					props: twoPanelBlock,
				},
			],
		},

		// Three Panel Block
		{
			title: 'Three Panel Block',
			background: 'gray',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'threePanelBlock',
					props: threePanelBlock,
				},
			],
		},

		// Reviews Section
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: reviews,
				},
			],
		},

		// FAQ's
		{
			title: '10x15 Storage Unit Size FAQs',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '10x15 Storage Unit Size FAQs',
						faqs,
					},
				},
			],
		},

		// Featured Content
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						pageType: pageTypes.SGP,
						title: 'Learn More About Storage Unit Size Options',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: selfStorage,
								content:
									'How to Pick the Right Size Self Storage Unit',
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: measured,
								content: 'How Are Storage Units Measured?',
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: tenIntoTen,
								content:
									'What Can You Fit in a 10x10 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/10x10-storage-unit-size-guide',
							},
							{
								title: 'General Storage Advice',
								date: 'October 31, 2025',
								image: tenIntoFifteen,
								content:
									'What Can You Fit in a 10x15 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit',
							},
						],
					},
				},
			],
		},

		// More Ways to store
		{
			title: 'Link to other PSPs',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						pageType: pageTypes.SGP,
						cards: [
							'ClimateControl',
							'Motorcycle',
							'10x10',
							'5x10',
						],
					},
				},
			],
		},

		// Nearby Units
		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
